import React from "react";
import { Box } from "@mui/material";
import { BeaconFilterButton } from "../../components/BeaconFilterButton";

const CalenderActions: React.FC = () => {

  return (
    <Box sx={{ display: "flex", alignItems: "end" }}>
      <BeaconFilterButton />
    </Box>
  );
};

export default CalenderActions;
